import { Box, Typography, alpha, makeStyles } from '@material-ui/core';
import React from 'react';
import { GetHandleProps, SliderItem } from 'react-compound-slider';

const thumbHeight = 10;

const useStyles = makeStyles((theme) => ({
  handle: {
    background: theme.palette.secondary.main,
    marginLeft: `${thumbHeight * -0.5}px`,
    marginTop: `${thumbHeight * -0.5 + 1}px`,
    width: `${thumbHeight}px`,
    height: `${thumbHeight}px`,
    borderRadius: '50%',
    zIndex: 2,
    cursor: 'pointer',
    position: 'absolute',
    whiteSpace: 'nowrap'
  },
  handleText: {
    position: 'absolute',
    transform: 'translateX(-50%)',
    top: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    background: alpha(theme.palette.background.default, 0.8)
  }
}));

interface SliderHandleProps {
  handle: SliderItem;
  value: string;
  getHandleProps: GetHandleProps;
}

const SliderHandle: React.VFC<SliderHandleProps> = ({
  handle,
  value,
  getHandleProps
}) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Box
        className={classes.handle}
        style={{ left: `${handle.percent}%` }}
        {...getHandleProps(handle.id)}
      />
      <Typography
        className={classes.handleText}
        variant="body2"
        color="secondary"
        style={{ left: `${handle.percent}%` }}
      >
        {value}
      </Typography>
    </React.Fragment>
  );
};

export default SliderHandle;
